import React from 'react';
import { Form } from '../../../../components/Form';
import { Card } from '../../../../components';
import { useAgentPrompts } from '../../../../pages/agent/hooks/useAgentPrompts';
import { PROMPT_FIELDS } from './constants';
import { PromptFieldEditor } from './PromptFieldEditor';

type PromptsTabProps = {
  agentId: string;
  disabled?: boolean;
};

export const PromptsTab: React.FC<PromptsTabProps> = ({
  agentId,
  disabled,
}) => {
  const {
    updating,
    formKey,
    savePrompt,
    formValues,
    setFormValues,
    llmModels,
  } = useAgentPrompts(agentId);

  return (
    <Card
      collapsable={false}
      name="agentpage.prompts"
      title=""
      size="unset"
      withOverflow={false}
      contentClassName="flex flex-col gap-y-md"
    >
      <Form initialValue={formValues} onChange={setFormValues} key={formKey}>
        {PROMPT_FIELDS.map(({ name, label, hint, hideModelFields }) => (
          <PromptFieldEditor
            key={name}
            name={name}
            label={label}
            hint={hint}
            hideModelFields={hideModelFields}
            formValues={formValues}
            llmModels={llmModels || []}
            disabled={disabled}
            updating={updating}
            onSave={savePrompt}
          />
        ))}
      </Form>
    </Card>
  );
};
